import React from 'react';
import { Button } from '@mui/material';  // 追加

const sizes = [48, 72, 96, 144, 192, 512];  // 追加

const ManifestGenerator = () => {
    const generateManifest = () => {
        const manifest = {
            name: "PWA Icon Generator",
            short_name: "IconGen",
            icons: sizes.map((size) => ({
                src: `icon-${size}x${size}.png`,
                sizes: `${size}x${size}`,
                type: "image/png",
            })),
            start_url: ".",
            display: "standalone",
            background_color: "#ffffff",
            theme_color: "#000000",
        };

        const blob = new Blob([JSON.stringify(manifest, null, 2)], {
            type: "application/json",
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'manifest.json';
        link.click();
    };

    return (
        <div>
            <Button variant="contained" color="primary" onClick={generateManifest}>
                Generate manifest.json
            </Button>
        </div>
    );
};

export default ManifestGenerator;
